import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VisitorBlacklist } from 'src/app/models/dtos/access-controller/visitor-blacklist';
import { VisitorBlacklistService } from 'src/app/services/access-controler/visitor-blacklist.service';
import { MessageUtil } from 'src/app/utils/message.util';

/**
 * ICES-38 — a própria funcionalidade de Blacklist: lista os bloqueios ativos da marina com busca
 * por CPF ou nome, retira um bloqueio e inclui um CPF (com ou sem cadastro de convidado).
 * Aberto pelo botão "Blacklist" da tela de Cadastro de Convidados.
 */
@Component({
  selector: 'app-visitor-blacklist-dialog',
  templateUrl: './visitor-blacklist-dialog.component.html',
  styleUrls: ['./visitor-blacklist-dialog.component.scss'],
})
export class VisitorBlacklistDialogComponent implements OnInit {
  entries: VisitorBlacklist[] = [];
  search = '';
  loading = false;
  changed = false;

  newFederalId = '';
  newName = '';
  newReason = '';

  constructor(
    public dialog: DynamicDialogRef,
    private visitorBlacklistService: VisitorBlacklistService,
    private messageUtil: MessageUtil
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.visitorBlacklistService.list(this.search?.trim()).subscribe({
      next: (list) => {
        this.entries = list || [];
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
        this.showError(error, 'Não foi possível carregar a blacklist.');
      },
    });
  }

  clearSearch(): void {
    this.search = '';
    this.load();
  }

  add(): void {
    const digits = (this.newFederalId || '').replace(/\D/g, '');
    if (digits.length !== 11) {
      this.messageUtil.generateMessage('warning', 'Atenção', 'Informe o CPF completo (11 dígitos).');
      return;
    }
    this.visitorBlacklistService
      .add({
        federalId: digits,
        name: this.newName?.trim() || undefined,
        reason: this.newReason?.trim() || undefined,
      })
      .subscribe({
        next: () => {
          this.changed = true;
          this.messageUtil.generateMessage('success', 'Sucesso', 'CPF adicionado à blacklist.');
          this.newFederalId = '';
          this.newName = '';
          this.newReason = '';
          this.load();
        },
        error: (error) => this.showError(error, 'Não foi possível adicionar à blacklist.'),
      });
  }

  remove(entry: VisitorBlacklist): void {
    Swal.fire({
      title: 'Retirar da blacklist?',
      html:
        '<b>' + (entry.name || 'Sem nome') + '</b><br>CPF ' + entry.federalId +
        '<br><small>O convidado volta a poder receber convites. O acesso que foi revogado ao bloquear ' +
        'não volta sozinho: o titular precisa emitir um convite novo.</small>',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Retirar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }
      this.visitorBlacklistService.remove(entry.id).subscribe({
        next: () => {
          this.changed = true;
          this.messageUtil.generateMessage('success', 'Sucesso', 'Convidado retirado da blacklist.');
          this.load();
        },
        error: (error) => this.showError(error, 'Não foi possível retirar da blacklist.'),
      });
    });
  }

  close(): void {
    this.dialog.close(this.changed);
  }

  private showError(error: any, fallback: string): void {
    const exception = error?.error?.data?.exception;
    if (exception) {
      this.messageUtil.generateMessage(exception.type, exception.title, exception.message);
    } else {
      this.messageUtil.generateMessage('error', 'Erro', error?.error?.message || fallback);
    }
  }
}
